export default "__VITE_ASSET__2Sga5iB4__"